import Vue from 'vue'

export default class ExceptionService{
	constructor() {
		this.stacks = []
		
		this.catchVueException()
	    this.catchNormalSyncException()
		this.catchAsyncException()
	}
	
	catchVueException(){
		Vue.config.errorHandler = ({message}, vm, info) => {
			//console.log('vue error', message)
		}
	}
	
	catchNormalSyncException(){
		window.addEventListener('error', event => {
			//console.log('window.error === ', event.message)
		})
	}
	
	catchAsyncException(){
		window.addEventListener('unhandledrejection', event => {
			//console.log('unhandledrejection ===', event.reason)
		})
	}
	
	report(){
		
	}
}